const criptografaSenha = (PublicKey, senha) => {
    try {
        let System = window.System;
        const data = System.Text.Encoding.UTF8.GetBytes(senha);
        let rsa = new System.Security.Cryptography.RSACryptoServiceProvider();
        rsa.FromXmlString(PublicKey);
        const encryptedBytes = rsa.Encrypt(data, true);
        const encryptedString = System.Convert.ToBase64String(encryptedBytes);
        return encryptedString;
    } catch (err) {
        return false;
    }
};
export default criptografaSenha;
